import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../modules';

export const selectAppState = createSelector(
  (state: AppState) => state,
  (state) => state,
);
